// assets
import { BugFilled,StarFilled,SlidersFilled, FolderFilled  } from "@ant-design/icons";
import { WeedIcon } from "./icons";
import Config from '../config.json'


const headers =  {
    "X-API-Key": Config.X_API_KEY,
  }

  const sidebarData = await fetch(`${Config.IPM_SERVER_URL}/api/crops/get-all-crops-with-details`, {
  headers: headers,
});

const data = await sidebarData.json();


const children = data.weeds.map((weed)=> ({
    id: weed?.id,
    title: weed?.name,
    type: "dynamic-item",
    url: weed?.url,
}));


// ==============================|| MENU ITEMS - EXTRA PAGES ||============================== //

const dynamicweedpages = {
  id: "dynamic-weeds",
  title: "Weeds",
  type: "dynamic-weeds",
  app: 'ipms',
  children: [
    ...children
  ],
};

export default dynamicweedpages;
